/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  DAILY_DESTINATION_FEE_LABEL,
  DAILY_RESORT_FEE_LABEL,
  DAILY_TOURISM_MARKETING_FEE_LABEL,
  DESTINATION_AMENITY_LABEL,
  DESTINATION_FEE_DESCRIPTION,
  FEE_LABEL,
  RESORT_FEE_DESCRIPTION,
  RESORT_LABEL,
  SURCHARGE_MANDATORY_FEE_LABEL,
  SURCHARGE_ORDINANCE_COST_DESCRIPTION,
  TOURISM_MARKETING_FEE_DESCRIPTION,
} from '../../../constants/CommonConstants';
import { MandatoryFeeFlags } from '../PropertiesListWrapper/PropertiesListWrapper.types';

//function to set mandatory fee title
export const constructMandatoryFeeTitle = (
  isResort: boolean | string,
  isLACountyFee: boolean,
  isMarketingFee: boolean,
  isDestinationFee: boolean,
  jsonContent: any
) => {
  let title = '';

  title = isResort
    ? (jsonContent?.resortLabel ?? RESORT_LABEL) + ' ' + (jsonContent?.feeLabel ?? FEE_LABEL)
    : isLACountyFee
    ? jsonContent?.surchargeMandatoryFeeLabel ?? SURCHARGE_MANDATORY_FEE_LABEL
    : isMarketingFee
    ? jsonContent?.tourismMarketingFeeLabel
    : isDestinationFee
    ? (jsonContent?.destinationAmenityLabel ?? DESTINATION_AMENITY_LABEL) + ' ' + (jsonContent?.feeLabel ?? FEE_LABEL)
    : '';

  return title;
};

//function to identify type of mandatory fee
export const identifyTypeOfMandatoryFee = (propertyDataOrDescriptions: any): MandatoryFeeFlags => {
  let isResort: boolean | string = false;
  let isLACountyFee = false;
  let isMarketingFee = false;
  let isDestinationFee = false;

  // Allow passing either the full propertyData or just descriptions array
  const descriptions = Array.isArray(propertyDataOrDescriptions)
    ? propertyDataOrDescriptions
    : propertyDataOrDescriptions?.descriptions ?? [];

  // if propertyData has explicit resort flag, prefer it
  if (!Array.isArray(propertyDataOrDescriptions) && propertyDataOrDescriptions?.basicInformation?.resort) {
    isResort = propertyDataOrDescriptions.basicInformation.resort;
  }

  if (Array.isArray(descriptions)) {
    descriptions.forEach((item: { type?: { code?: string; enumCode?: string } }) => {
      const enumCode = (item?.type?.enumCode ?? '').toString().toUpperCase();
      if (enumCode === RESORT_FEE_DESCRIPTION) {
        isResort = true;
      } else if (enumCode === SURCHARGE_ORDINANCE_COST_DESCRIPTION) {
        isLACountyFee = true;
      } else if (enumCode === DESTINATION_FEE_DESCRIPTION) {
        isDestinationFee = true;
      } else if (enumCode === TOURISM_MARKETING_FEE_DESCRIPTION) {
        isMarketingFee = true;
      }
    });
  }

  return { isResort, isLACountyFee, isMarketingFee, isDestinationFee };
};

//function to construct tool tip data
export const constructToolTipTitle = (
  isResort: boolean | string,
  isLACountyFee: boolean,
  isMarketingFee: boolean,
  isDestinationFee: boolean,
  labels: any
) => {
  let toolTipTitle = '';

  if (isResort) {
    toolTipTitle = labels?.dailyResortFeeLabel ? labels?.dailyResortFeeLabel : DAILY_RESORT_FEE_LABEL;
  } else if (isLACountyFee) {
    toolTipTitle = labels?.surchargeMandatoryFeeLabel
      ? labels?.surchargeMandatoryFeeLabel
      : SURCHARGE_MANDATORY_FEE_LABEL;
  } else if (isMarketingFee) {
    toolTipTitle = labels?.dailyTourismMarketingFeeLabel
      ? labels?.dailyTourismMarketingFeeLabel
      : DAILY_TOURISM_MARKETING_FEE_LABEL;
  } else if (isDestinationFee) {
    toolTipTitle = labels?.dailyDestinationFeeLabel ? labels?.dailyDestinationFeeLabel : DAILY_DESTINATION_FEE_LABEL;
  } else {
    toolTipTitle = '';
  }

  return toolTipTitle;
};
